var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator text-right",attrs:{"id":_vm.bubbleId}},[_vm._v("\n    Your media is uploading... Please wait.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }